import { render, staticRenderFns } from "./FleetHealthHistoryReportCard.vue?vue&type=template&id=06c18858&scoped=true&"
import script from "./FleetHealthHistoryReportCard.vue?vue&type=script&lang=js&"
export * from "./FleetHealthHistoryReportCard.vue?vue&type=script&lang=js&"
import style0 from "./FleetHealthHistoryReportCard.vue?vue&type=style&index=0&id=06c18858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c18858",
  null
  
)

export default component.exports